import AlgaPicture from '../algaPicture';
import AlgaPictureApi, { AlgaPictureDOI } from '../api/algaPictureApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CellOperate from 'src/components/agGridComponent/cellOperate';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import FileUtil from 'src/util/fileUtil';
import { Toast } from 'src/util/toast';

export default class AlgaPictureService extends ListPageService {
    ctx: AlgaPicture;

    constructor(ctx: AlgaPicture) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '文件名',
                field: 'file_name',
                minWidth: 300,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 180,
                maxWidth: 180,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: AlgaPictureDOI.RowDataI = params.data;
                            await t.delete(data.id);
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: DatePicker,
                label: '上传时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: {
                    value: DateTimeUtil.getDayInterval(7),
                    type: 'daterange',
                    format: 'yyyy-MM-dd',
                    placeholder: '请选择时间',
                    clearable: false,
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<AlgaPictureDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    async delete(id: number) {
        let { code } = await AlgaPictureApi.delete(id);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await AlgaPictureApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();
        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
